/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/* eslint-disable
    camelcase
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

import FileBrowserActions from 'file-browser/FileBrowserActions';
import MultipleFolderSelector from 'file-browser/MultipleFolderSelector';
import FormGroup from 'ui-library/bs/FormGroup';
import Modal from 'ui-library/modals/Modal';

interface Props {
  initialFolders: Array<any>;
  onRequestClose: (...args: Array<any>) => any;
}

interface State {
  folders: Array<any>;
}

class HideProjectModal extends React.Component<Props, State> {
  state: State = {
    folders: this.props.initialFolders,
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  submitHandler = () => {
    const sourceIds = this.state.folders.map(({source}) => source.id);
    FileBrowserActions.hideSources(sourceIds);
    this.props.onRequestClose();
  };

  render(): JSX.Element {
    return (
      <Modal
        title="Hide project"
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={this.submitHandler}
        wrapInForm={false}
        buttons={[
          {
            text: 'Hide projects',
            disabled: this.state.folders.length === 0,
            submit: true,
          },
        ]}
      >
        <div>
          <span>
            {`Hiding a project removes it from your project listings to reduce clutter. You can \
      still show hidden projects from the bottom of the listing.`}
          </span>
        </div>
        <div>
          <FormGroup>
            <h5>To hide multiple projects, add them here:</h5>
            <MultipleFolderSelector
              // TODO(T2222): Change this to `folder.id` once folderResp ID is API ID.
              selectedFolderIds={this.state.folders.map(({api_identifier, id}) =>
                api_identifier != null ? api_identifier : id
              )}
              onSelectFolders={(folders) => {
                this.setState({folders});
              }}
              showRegistries={false}
            />
          </FormGroup>
        </div>
      </Modal>
    );
  }
}

export default HideProjectModal;
